import { LOWERCASE_SORT_ID_KEY } from 'constants/constants';

export const getSortIdQueryParam = (queryParams: Record<string, any>) => {
  const paramKey = Object.keys(queryParams).find(
    (key) => key.toLowerCase() === LOWERCASE_SORT_ID_KEY,
  );

  return queryParams[paramKey || ''];
};
